import { render } from "./freeText.vue?vue&type=template&id=c755843a&scoped=true"
import script from "./freeText.vue?vue&type=script&lang=js"
export * from "./freeText.vue?vue&type=script&lang=js"

import "./freeText.vue?vue&type=style&index=0&id=c755843a&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c755843a"]])

export default __exports__